import { jsx } from "react/jsx-runtime";
import { keyframes } from "../../../../../external/@emotion/react/dist/emotion-react.browser.esm.js";
import { Reveal } from "../../../../../external/react-awesome-reveal/dist/index.js";
const fadeUpSmallKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
const FadeUpSmall = ({ keyframes: keyframes2, ...rest }) => {
  return /* @__PURE__ */ jsx(
    Reveal,
    {
      keyframes: fadeUpSmallKeyframes,
      ...rest
    }
  );
};
const FadeUpSmall$1 = FadeUpSmall;
export {
  FadeUpSmall$1 as default
};
